module.exports = __webpack_public_path__ + "static/media/22.b436e5e7.jpg";